<template>
  <breadCrumbs title="  Image Cropper" main="Bonus UI" title1="Image Cropper" />
  <div class="container-fluid">
            <div class="img-cropper">
              <div class="row">
                <div class="col-sm-12 text-start">
                    <imageCropper/>
                </div>
              </div>
            </div>
            </div>
</template>
<script>
import imageCropper from "./imageCropper.vue"
export default {
    components:{
        imageCropper,
    }
}
</script>